export default __webpack_public_path__ + "static/media/balance_bike_tile.f998ebf0.jpg";